import { render, staticRenderFns } from "./CustomSkeletonPreloader.vue?vue&type=template&id=40167158"
import script from "./CustomSkeletonPreloader.vue?vue&type=script&lang=ts"
export * from "./CustomSkeletonPreloader.vue?vue&type=script&lang=ts"
import style0 from "./CustomSkeletonPreloader.vue?vue&type=style&index=0&id=40167158&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports